import { GREAT_WHITE, EERIE } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIToggle from 'UIComponents/input/UIToggle';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmbeddedTopContentWithBottomBorder = styled(UIFlex).withConfig({
  displayName: "ActivationToggle__EmbeddedTopContentWithBottomBorder",
  componentId: "s74n82-0"
})(["border-bottom:", " solid 1px;padding:8px 24px;"], GREAT_WHITE);
const ActivationToggle = ({
  hasWorkflowsAppAccess,
  isFlowEnabled,
  onChange
}) => {
  const noWorkflowAppAccessAndWorkflowIsOn = !hasWorkflowsAppAccess && isFlowEnabled;
  return /*#__PURE__*/_jsxs(EmbeddedTopContentWithBottomBorder, {
    align: "center",
    justify: "between",
    children: [/*#__PURE__*/_jsxs(UIFormLabel, {
      htmlFor: "embed-toggle",
      children: [isFlowEnabled && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIStatusDot, {
          use: "success"
        }), /*#__PURE__*/_jsx(Small, {
          style: {
            color: EERIE
          },
          weight: "regular",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.embed.flowCanvasContainer.workflowStatus.isOn"
          })
        })]
      }), !isFlowEnabled && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIStatusDot, {
          use: "default"
        }), /*#__PURE__*/_jsx(Small, {
          style: {
            color: EERIE
          },
          weight: "regular",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.embed.flowCanvasContainer.workflowStatus.isOff"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(UITooltip, {
      disabled: noWorkflowAppAccessAndWorkflowIsOn,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.embed.flowCanvasContainer.workflowStatus.reviewTooltip"
      }),
      children: /*#__PURE__*/_jsx(UIToggle, {
        checked: isFlowEnabled,
        id: "embed-toggle",
        onChange: onChange,
        size: "xs"
      })
    })]
  });
};
export default ActivationToggle;